export default __webpack_public_path__ + "static/media/Beard_7_C5.bff056bc.svg";